// Deprecated. Will be removed as part of [LK-887].
export default Object.freeze({
  CURRENT_REVIEWER: 'CURRENT_REVIEWER',
  OTHER_REVIEWERS: 'OTHER_REVIEWERS',
});
